/* Essance wishlist (built into the theme, no app).
   Saved in the shopper's browser. A Share link carries the list itself, so
   whoever opens it sees the same products and can add them all to their cart. */
(function(){
  'use strict';
  var KEY = 'essWishlist.v1';
  var LIST_PATH = '/collections/all?view=wishlist';
  var MAX_ITEMS = 50;
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]{0,254}$/;
  var ID_RE = /^\d{1,20}$/;

  /* ---------- storage ---------- */
  function clean(list){
    var seen = {}, out = [];
    (Array.isArray(list) ? list : []).forEach(function(i){
      if(!i || !HANDLE_RE.test(String(i.h))) return;
      var v = i.v != null && ID_RE.test(String(i.v)) ? String(i.v) : null;
      var k = i.h + ':' + (v || '');
      if(seen[k]) return;
      seen[k] = 1;
      out.push({ h: String(i.h), v: v });
    });
    return out.slice(0, MAX_ITEMS);
  }
  function read(){
    try { return clean(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch(e){ return []; }
  }
  function write(list){
    try { localStorage.setItem(KEY, JSON.stringify(clean(list))); } catch(e){}
    refresh();
  }
  function hasProduct(h){ return read().some(function(i){ return i.h === h; }); }
  function hasItem(h, v){ return read().some(function(i){ return i.h === h && (i.v || '') === (v || ''); }); }
  function addItem(h, v){ var l = read(); if(!hasItem(h, v)) l.unshift({ h: h, v: v || null }); write(l); }
  function removeItem(h, v){ write(read().filter(function(i){ return !(i.h === h && (i.v || '') === (v || '')); })); }
  function removeProduct(h){ write(read().filter(function(i){ return i.h !== h; })); }

  /* ---------- share links ---------- */
  function encodeItems(list){ return list.map(function(i){ return i.v ? i.h + ':' + i.v : i.h; }).join(','); }
  function decodeItems(str){
    return clean(String(str || '').split(',').map(function(p){
      var bits = p.split(':');
      return { h: (bits[0] || '').trim().toLowerCase(), v: (bits[1] || '').trim() || null };
    }));
  }
  function cleanName(n){
    return Array.from(String(n || '')).filter(function(c){ return c.charCodeAt(0) > 31 && c !== '<' && c !== '>'; }).join('').trim().slice(0, 40);
  }
  function shareUrl(list, name){
    var url = location.origin + LIST_PATH + '&items=' + encodeURIComponent(encodeItems(list));
    name = cleanName(name);
    if(name) url += '&name=' + encodeURIComponent(name);
    return url;
  }
  /* Phones: native share sheet. Elsewhere: copy to clipboard. done(copied) runs
     unless the shopper simply cancelled the share sheet. */
  function shareList(url, done){
    if(navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)){
      navigator.share({ title: 'My Essance Wishlist', url: url }).catch(function(err){
        if(!err || err.name !== 'AbortError') done(false);
      });
    } else if(navigator.clipboard && window.isSecureContext){
      navigator.clipboard.writeText(url).then(function(){ done(true); }, function(){ done(false); });
    } else { done(false); }
  }

  /* ---------- toast (confirms a save and says where it went) ---------- */
  var toastEl, toastTimer;
  function hideToastSoon(){
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ if(toastEl) toastEl.classList.remove('is-visible'); }, 3500);
  }
  function toast(msg, linkText, href){
    if(!toastEl){
      toastEl = el('div', 'wl-toast');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.addEventListener('mouseenter', function(){ clearTimeout(toastTimer); });
      toastEl.addEventListener('mouseleave', hideToastSoon);
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    toastEl.appendChild(el('span', 'wl-toast__msg', msg));
    if(linkText){ var a = el('a', 'wl-toast__link', linkText); a.href = href; toastEl.appendChild(a); }
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    hideToastSoon();
  }
  function optName(p){
    return String(p.options && p.options[0] && p.options[0].name || 'option').toLowerCase().replace(/s$/, '');
  }

  /* ---------- toggles (product page + cards) ---------- */
  function currentVariant(btn){
    if(!btn.hasAttribute('data-wishlist-variant-source')) return null;
    var sel = document.querySelector('[data-product-variant-select]');
    /* single-variant products have no select: save the product, not a variant */
    return sel && ID_RE.test(String(sel.value)) ? String(sel.value) : null;
  }
  function isSaved(btn){
    var h = btn.getAttribute('data-handle');
    return btn.hasAttribute('data-wishlist-variant-source') ? hasItem(h, currentVariant(btn)) : hasProduct(h);
  }
  function paintToggle(btn){
    var on = isSaved(btn);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-wishlist-label]');
    var name = btn.getAttribute('data-product-title') || 'this product';
    if(label) label.textContent = on ? 'Saved to Wishlist' : 'Save to Wishlist';
    else btn.setAttribute('aria-label', on ? 'Remove ' + name + ' from wishlist' : 'Save ' + name + ' to wishlist');
  }
  function onToggle(btn){
    var h = btn.getAttribute('data-handle');
    if(!HANDLE_RE.test(h)) return;
    if(btn.hasAttribute('data-wishlist-variant-source')){
      var v = currentVariant(btn);
      if(hasItem(h, v)){ removeItem(h, v); toast('Removed from your wishlist'); }
      else { addItem(h, v); toast('Saved to your wishlist', 'View', LIST_PATH); }
    } else {
      if(hasProduct(h)){ removeProduct(h); toast('Removed from your wishlist'); }
      else { addItem(h, null); toast('Saved to your wishlist', 'View', LIST_PATH); }
    }
  }
  var HEART = '<svg class="wl-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"/></svg>';
  function injectCardHearts(){
    document.querySelectorAll('.product-card').forEach(function(card){
      if(card.querySelector('.wl-card-heart')) return;
      var media = card.querySelector('.product-card__media');
      var m = media && (media.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if(!m) return;
      var title = card.querySelector('h3');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wl-card-heart';
      btn.setAttribute('data-wishlist-toggle', '');
      btn.setAttribute('data-handle', decodeURIComponent(m[1]).toLowerCase());
      btn.setAttribute('data-product-title', title ? title.textContent.trim() : '');
      btn.innerHTML = HEART;
      media.appendChild(btn);
    });
  }
  function refresh(){
    document.querySelectorAll('[data-wishlist-toggle]').forEach(paintToggle);
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = n;
      el.hidden = n === 0;
    });
    var link = document.querySelector('.header-wishlist-link');
    if(link) link.setAttribute('aria-label', n ? 'Wishlist, ' + n + (n === 1 ? ' item' : ' items') : 'Wishlist');
  }

  /* ---------- wishlist page ---------- */
  function money(cents){ return '$' + (Number(cents) / 100).toFixed(2); }
  function el(tag, cls, text){ var e = document.createElement(tag); if(cls) e.className = cls; if(text != null) e.textContent = text; return e; }
  var productCache = {};
  function loadProduct(h){
    if(!productCache[h]){
      productCache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return productCache[h];
  }
  function pickVariant(p, v){
    if(!p || !p.variants || !p.variants.length) return null;
    var match = v && p.variants.filter(function(x){ return String(x.id) === String(v); })[0];
    return match || p.variants.filter(function(x){ return x.available; })[0] || p.variants[0];
  }
  function imgSrc(p){
    /* Always the product's main photo: some variant photos are shade swatches
       (e.g. lipsticks), which read as a smear rather than the product. */
    var src = p.featured_image || '';
    if(!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }
  function updateCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var n = c.item_count;
      document.querySelectorAll('[data-header-cart-count]').forEach(function(s){ s.textContent = n; });
      document.querySelectorAll('[data-header-cart-badge]').forEach(function(s){ s.textContent = n; s.hidden = n === 0; });
      document.querySelectorAll('[data-header-cart]').forEach(function(a){ a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
    }).catch(function(){});
  }
  function addToCart(ids){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function(id){ return { id: Number(id), quantity: 1 }; }) })
    }).then(function(r){ return r.ok ? r.json() : r.json().then(function(e){ throw e; }); });
  }

  function initPage(root){
    var params = new URLSearchParams(location.search);
    var shared = params.has('items');
    var list = shared ? decodeItems(params.get('items')) : read();
    var sharedName = shared ? cleanName(params.get('name')) : '';
    var q = function(s){ return root.querySelector(s); };
    var listEl = q('[data-wl-list]'), status = q('[data-wl-status]');
    var rows = [];

    var heading = shared ? (sharedName ? sharedName + "'s Wishlist" : 'A Shared Wishlist') : 'Your Wishlist';
    document.title = heading + ' | Essance';
    if(shared){
      q('[data-wl-title]').textContent = heading;
      q('[data-wl-intro]').textContent = 'Someone shared these picks with you. Add them all to your cart in one tap, or pick and choose.';
      q('[data-wl-share]').hidden = true;
      q('[data-wl-save-shared]').hidden = false;
      q('[data-wl-mine]').hidden = false;
    }
    function say(msg){ status.textContent = msg; }

    function render(){
      listEl.textContent = '';
      var visible = rows.filter(function(r){ return !r.removed; });
      q('[data-wl-empty]').hidden = visible.length > 0;
      q('[data-wl-bar]').hidden = visible.length === 0;
      if(shared && visible.length === 0){
        q('[data-wl-empty]').querySelector('p').textContent = 'This shared list is empty or the link is incomplete.';
      }
      visible.forEach(function(r){
        var li = el('li', 'wl-item');
        if(!r.product){
          li.appendChild(el('span', 'wl-item__img'));
          var gone = el('div'); gone.appendChild(el('span', 'wl-item__title', 'This product is no longer available'));
          li.appendChild(gone);
          if(!shared){
            var rm0 = el('button', 'wl-item__remove', 'Remove'); rm0.type = 'button';
            rm0.addEventListener('click', function(){ removeItem(r.item.h, r.item.v); r.removed = true; render(); });
            var a0 = el('div', 'wl-item__actions'); a0.appendChild(rm0); li.appendChild(a0);
          }
          listEl.appendChild(li); return;
        }
        var p = r.product, v = r.variant;
        if(r.needsChoice){
          var cimg = el('img', 'wl-item__img'); cimg.alt = p.title; cimg.loading = 'lazy'; cimg.width = 88; cimg.height = 88;
          var csrc = imgSrc(p); if(csrc) cimg.src = csrc;
          var clink = el('a'); clink.href = p.url; clink.appendChild(cimg); li.appendChild(clink);
          var cinfo = el('div');
          var ct = el('a', 'wl-item__title', p.title); ct.href = p.url; cinfo.appendChild(ct);
          cinfo.appendChild(el('span', 'wl-item__variant', 'Pick a ' + optName(p) + ' on the product page'));
          li.appendChild(cinfo);
          var cact = el('div', 'wl-item__actions');
          var choose = el('a', 'btn btn-outline wl-btn wl-item__btn', 'Choose Option'); choose.href = p.url; cact.appendChild(choose);
          if(!shared){
            var crm = el('button', 'wl-item__remove', 'Remove'); crm.type = 'button';
            crm.setAttribute('aria-label', 'Remove ' + p.title + ' from wishlist');
            crm.addEventListener('click', function(){ removeItem(r.item.h, r.item.v); r.removed = true; render(); say(p.title + ' removed.'); });
            cact.appendChild(crm);
          }
          li.appendChild(cact);
          listEl.appendChild(li); return;
        }
        var multi = p.variants.length > 1;
        var href = p.url + (multi ? '?variant=' + v.id : '');
        var img = el('img', 'wl-item__img'); img.alt = p.title; img.loading = 'lazy'; img.width = 88; img.height = 88;
        var src = imgSrc(p); if(src) img.src = src;
        var link = el('a'); link.href = href; link.appendChild(img);
        li.appendChild(link);
        var info = el('div');
        var t = el('a', 'wl-item__title', p.title); t.href = href; info.appendChild(t);
        if(multi && v.title !== 'Default Title') info.appendChild(el('span', 'wl-item__variant', v.title));
        var price = el('span', 'wl-item__price', money(v.price));
        if(!v.available){ price.appendChild(document.createTextNode(' ')); price.appendChild(el('span', 'wl-item__soldout', 'Sold out')); }
        info.appendChild(price);
        li.appendChild(info);
        var actions = el('div', 'wl-item__actions');
        var add = el('button', 'btn btn-outline wl-btn wl-item__btn', v.available ? 'Add to Cart' : 'Sold Out'); add.type = 'button';
        add.disabled = !v.available;
        add.addEventListener('click', function(){
          add.disabled = true;
          addToCart([v.id]).then(function(){ add.textContent = 'Added'; say(p.title + ' added to your cart.'); updateCartCount(); })
            .catch(function(e){ add.disabled = false; say((e && e.description) || 'Could not add that item. Please try again.'); });
        });
        actions.appendChild(add);
        if(!shared){
          var rm = el('button', 'wl-item__remove', 'Remove'); rm.type = 'button';
          rm.setAttribute('aria-label', 'Remove ' + p.title + ' from wishlist');
          rm.addEventListener('click', function(){ removeItem(r.item.h, r.item.v); r.removed = true; render(); say(p.title + ' removed.'); });
          actions.appendChild(rm);
        }
        li.appendChild(actions);
        listEl.appendChild(li);
      });
    }

    list.forEach(function(){
      var li = el('li', 'wl-item wl-item--skeleton'); li.setAttribute('aria-hidden', 'true');
      li.appendChild(el('span', 'wl-item__img'));
      var d = el('div');
      var s1 = el('span', 'wl-skel'); s1.style.width = '60%'; d.appendChild(s1);
      var s2 = el('span', 'wl-skel'); s2.style.width = '30%'; d.appendChild(s2);
      li.appendChild(d);
      listEl.appendChild(li);
    });
    if(!list.length){ render(); return; }

    Promise.all(list.map(function(item){
      return loadProduct(item.h).then(function(p){
        /* Saved from a product card without picking a shade/flavor: don't guess one. */
        var needsChoice = !!(p && !item.v && p.variants && p.variants.length > 1);
        return { item: item, product: p, needsChoice: needsChoice, variant: needsChoice ? null : pickVariant(p, item.v) };
      });
    })).then(function(r){ rows = r; render(); });

    q('[data-wl-add-all]').addEventListener('click', function(){
      var btn = this;
      var live = rows.filter(function(r){ return !r.removed && r.product && r.variant; });
      var ok = live.filter(function(r){ return r.variant.available; }).map(function(r){ return r.variant.id; });
      var skipped = live.length - ok.length;
      var choose = rows.filter(function(r){ return !r.removed && r.needsChoice; }).length;
      var note = (skipped ? ', ' + skipped + ' sold out skipped' : '') + (choose ? ', ' + choose + (choose === 1 ? ' still needs' : ' still need') + ' an option picked' : '');
      if(!ok.length){ say(choose ? 'Pick an option for each item first, using Choose Option.' : 'Everything on this list is sold out right now.'); return; }
      btn.disabled = true;
      addToCart(ok).then(function(){
        say(ok.length + (ok.length === 1 ? ' item' : ' items') + ' added' + note + '.' + (choose ? '' : ' Taking you to your cart.'));
        if(choose){ btn.disabled = false; updateCartCount(); } else { setTimeout(function(){ location.href = '/cart'; }, 700); }
      }).catch(function(e){ btn.disabled = false; say((e && e.description) || 'Could not add those items. Please try again.'); });
    });

    q('[data-wl-save-shared]').addEventListener('click', function(){
      var mine = read();
      list.forEach(function(i){ if(!mine.some(function(m){ return m.h === i.h && (m.v || '') === (i.v || ''); })) mine.push(i); });
      write(mine);
      say('Saved to your wishlist.');
    });

    q('[data-wl-share-btn]').addEventListener('click', function(){
      var url = shareUrl(read(), q('[data-wl-name]').value);
      var linkBox = q('[data-wl-share-link]');
      function showLink(msg){ linkBox.value = url; linkBox.hidden = false; linkBox.focus(); linkBox.select(); say(msg); }
      shareList(url, function(copied){ showLink(copied ? 'Link copied. Paste it in a text or email.' : 'Copy this link to share your list.'); });
    });
  }

  /* ---------- cart page: "Saved for later" + "Save for later" ---------- */
  function initSavedForLater(root){
    var list = read();
    if(!list.length) return;
    var head = el('div', 'saved-later__head');
    head.appendChild(el('h2', 'saved-later__title', 'Saved for Later'));
    var all = el('a', 'saved-later__all', 'View wishlist (' + list.length + ')'); all.href = LIST_PATH;
    var share = el('button', 'saved-later__share', 'Share'); share.type = 'button';
    share.setAttribute('aria-label', 'Share your wishlist');
    share.addEventListener('click', function(){
      var url = shareUrl(read(), '');
      shareList(url, function(copied){
        if(copied) toast('Wishlist link copied. Paste it in a text or email.');
        else window.prompt('Copy this link to share your wishlist:', url);
      });
    });
    var links = el('div', 'saved-later__links');
    links.appendChild(share);
    links.appendChild(all);
    head.appendChild(links);
    var ul = el('ul', 'wl-list saved-later__list');
    root.textContent = '';
    root.appendChild(head);
    root.appendChild(ul);
    Promise.all(list.slice(0, 6).map(function(item){
      return loadProduct(item.h).then(function(p){
        var needs = !!(p && !item.v && p.variants && p.variants.length > 1);
        return { item: item, product: p, needsChoice: needs, variant: needs ? null : pickVariant(p, item.v) };
      });
    })).then(function(rows){
      rows.forEach(function(r){
        if(!r.product) return;
        var p = r.product, v = r.variant, multi = p.variants.length > 1;
        var href = p.url + (v && multi ? '?variant=' + v.id : '');
        var li = el('li', 'wl-item');
        var img = el('img', 'wl-item__img'); img.alt = p.title; img.loading = 'lazy'; img.width = 88; img.height = 88;
        var src = imgSrc(p); if(src) img.src = src;
        var a = el('a'); a.href = href; a.appendChild(img); li.appendChild(a);
        var info = el('div');
        var t = el('a', 'wl-item__title', p.title); t.href = href; info.appendChild(t);
        if(r.needsChoice){
          info.appendChild(el('span', 'wl-item__variant', 'Pick a ' + optName(p) + ' on the product page'));
        } else {
          if(multi) info.appendChild(el('span', 'wl-item__variant', v.title));
          var pr = el('span', 'wl-item__price', money(v.price));
          if(!v.available){ pr.appendChild(document.createTextNode(' ')); pr.appendChild(el('span', 'wl-item__soldout', 'Sold out')); }
          info.appendChild(pr);
        }
        li.appendChild(info);
        var act = el('div', 'wl-item__actions');
        if(r.needsChoice){
          var c = el('a', 'btn btn-outline wl-btn wl-item__btn', 'Choose Option'); c.href = p.url; act.appendChild(c);
        } else {
          var mv = el('button', 'btn btn-outline wl-btn wl-item__btn', v.available ? 'Move to Cart' : 'Sold Out'); mv.type = 'button';
          mv.disabled = !v.available;
          mv.addEventListener('click', function(){
            mv.disabled = true;
            addToCart([v.id]).then(function(){ removeItem(r.item.h, r.item.v); location.reload(); })
              .catch(function(e){ mv.disabled = false; toast((e && e.description) || 'Could not move that item. Please try again.'); });
          });
          act.appendChild(mv);
        }
        var rm = el('button', 'wl-item__remove', 'Remove'); rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove ' + p.title + ' from wishlist');
        rm.addEventListener('click', function(){
          removeItem(r.item.h, r.item.v);
          li.parentNode.removeChild(li);
          var left = read().length;
          all.textContent = 'View wishlist (' + left + ')';
          share.hidden = left === 0;
          if(!ul.children.length) root.hidden = true;
        });
        act.appendChild(rm);
        li.appendChild(act);
        ul.appendChild(li);
      });
      root.hidden = ul.children.length === 0;
    });
  }
  function initSaveForLater(){
    document.querySelectorAll('[data-save-later]').forEach(function(b){
      b.addEventListener('click', function(){
        var h = b.getAttribute('data-handle'), v = b.getAttribute('data-variant') || null, key = b.getAttribute('data-key');
        if(!HANDLE_RE.test(h) || !key) return;
        b.disabled = true;
        if(!hasItem(h, v)) addItem(h, v);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(r){ if(!r.ok) throw new Error('change failed'); location.reload(); })
          .catch(function(){ b.disabled = false; toast('Saved to your wishlist, but it is still in your cart. Refresh and try again.'); });
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(){
    injectCardHearts();
    document.addEventListener('click', function(e){
      var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
      if(!btn) return;
      e.preventDefault();
      e.stopPropagation();
      onToggle(btn);
    }, true);
    document.addEventListener('essance:variant-changed', refresh);
    window.addEventListener('storage', function(e){ if(e.key === KEY) refresh(); });
    var page = document.querySelector('[data-wishlist-page]');
    if(page) initPage(page);
    var saved = document.querySelector('[data-saved-for-later]');
    if(saved) initSavedForLater(saved);
    initSaveForLater();
    refresh();
  }
  window.EssWishlist = { read: read, decodeItems: decodeItems, encodeItems: encodeItems, shareUrl: shareUrl, clean: clean, cleanName: cleanName };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
